import * as types from '../mutation-type'
import api from '@/common/api.js'
const state ={
  userInfo:null,//用户信息
}
const SESSIONGID=api.login.userInfo;
const getters={
    getUserInfo(state){
      if(localStorage.getItem(SESSIONGID)){
        let userInfo=JSON.parse(localStorage.getItem(SESSIONGID));
        state.userInfo={
          userId:userInfo.userId,
          userName:userInfo.userName,
          tenantId:userInfo.tenantId,
          realName:userInfo.realName,
          phoneNumber:userInfo.phoneNumber
        }
      }else{
        if(state.userInfo){
          state.userInfo.userId=state.userInfo.userName=state.userInfo.tenantId=state.userInfo.realName=state.userInfo.phoneNumber='';
        }
       }
      return state.userInfo
    }
};

const mutations={
  [types.VLOGIN](state,info){
    state.userInfo=info;
    localStorage.setItem(SESSIONGID,info);
  },
  [types.LOGIN_OUT](state){
    state.userInfo=null;
    localStorage.removeItem(SESSIONGID);
  }
}

const actions={
  updateLogin({commit},info){
    commit(types.VLOGIN,info);
  },
  removeUserInfo({commit}){
    commit(types.LOGIN_OUT);
  }
}
export default{
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/moudel/login.js